import React from "react";
import { Backdrop, CircularProgress, Skeleton } from "@mui/material";

type CustomLoaderType = {
    isLoading: boolean;
    loaderType?: string;
    className?: any;
}

const CustomLoader = (props: CustomLoaderType) => {
    return (
        <>
            { (props.loaderType === "backdrop" || !props.loaderType) &&
                <Backdrop open={props.isLoading}>
                    <CircularProgress color="primary" />
                </Backdrop>
            }

            { props.loaderType === "circular" && props.isLoading &&
                <CircularProgress className={props.className} color="primary" />
            }

            { props.loaderType === "skeleton" && props.isLoading &&
                <>
                    <Skeleton sx={{marginBottom: '3rem'}} variant="rounded" height={30} width={600} />
                    <Skeleton sx={{marginBottom: '0.9rem', marginRight: '3rem'}} variant="rounded" height={60} />
                    <Skeleton sx={{marginBottom: '0.9rem', marginRight: '5rem'}} variant="rounded" height={100} />
                    <Skeleton sx={{marginBottom: '3rem'}} variant="rounded" height={80} />
                    <Skeleton variant="rounded" height={40} width={200} />
                </>
            }
        </>
    )
}

export default CustomLoader;